import axios from 'axios'
import { PayoutTicketActionResponse } from './_models'
import { API_URL } from '../../../../constants'

export const IN_PROGRESS_TOKEN = `${API_URL}/api/payout/in_progress/__token__`
export const FINISH_TOKEN = `${API_URL}/api/payout/complete/__token__`
export const CANCEL_TOKEN = `${API_URL}/api/payout/decline/__token__`
export const CHANGE_ADAPTER = `${API_URL}/api/payout/change-payment-adapter/__token__`
export const STOP_CASCADE = `${API_URL}/api/payout/__token__/stop-cascade`
export const RESEND_CALLBACK = `${API_URL}/api/internal/callback/resend`

export function inProgressTicketAPI(token: string) {
  return axios.post<PayoutTicketActionResponse>(IN_PROGRESS_TOKEN.replace('__token__', token))
}

export function finishTicketAPI(token: string, commission?: string) {
  return axios.post<PayoutTicketActionResponse>(
    FINISH_TOKEN.replace('__token__', token),
    commission && {
      commission,
    }
  )
}

export function cancelTicketAPI(token: string) {
  return axios.post<PayoutTicketActionResponse>(CANCEL_TOKEN.replace('__token__', token))
}

export function changPaymentTicketAPI(token: string) {
  return axios.post(CHANGE_ADAPTER.replace('__token__', token))
}

export function stopCascadeAPI(token: string) {
  return axios.post<PayoutTicketActionResponse>(STOP_CASCADE.replace('__token__', token))
}

export interface ResendCallbackResponse {
  success: boolean
  errors?: Record<string, string>
}

// Manually resend the merchant callback (КБ) for a ticket using its current state.
// Works for both payment and payout tickets (resolved by token on the backend).
export function resendCallbackAPI(token: string) {
  return axios.post<ResendCallbackResponse>(RESEND_CALLBACK, { token })
}
